document.addEventListener('DOMContentLoaded', () => {
    const categorySelect = document.querySelector('[data-category]');
    const bundlesField = document.querySelector('[data-bundles]');

    categorySelect.addEventListener('change', (e) => {
        if (e.target.value === 'logo-design') {
            bundlesField.style.display = 'block';
        } else {
            bundlesField.style.display = 'none';
        }
    });
});



// WEBPACK FOOTER //
// ./js/marketing/designConsultation.js